// ============================================================
// Tiny DOM helpers. No framework — just enough ergonomics to
// avoid writing document.getElementById 40 times.
// ============================================================

export const $  = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

export function el(tag, attrs = {}, ...children) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v == null || v === false) continue;
    if (k === 'class')        node.className = v;
    else if (k === 'style' && typeof v === 'object') Object.assign(node.style, v);
    else if (k.startsWith('on') && typeof v === 'function') node.addEventListener(k.slice(2).toLowerCase(), v);
    else if (k === 'html')    node.innerHTML = v;
    else                      node.setAttribute(k, v);
  }
  for (const c of children.flat()) {
    if (c == null || c === false) continue;
    node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

export function showToast(msg, kind = '') {
  const t = $('#toast');
  if (!t) return;
  t.textContent = msg;
  t.className = 'active ' + kind;
  clearTimeout(showToast._t);
  // 2026-10-09 — error toasts stay long enough to READ: the server's leave
  // refusals run 140–160 characters (usability-expert: ~70 ms a character,
  // at least 6 s). Success / info toasts keep the short 2.8 s.
  const ms = kind === 'error' ? Math.max(6000, String(msg || '').length * 70) : 2800;
  showToast._t = setTimeout(() => { t.className = ''; }, ms);
}

export function fmtNum(n, digits = 0) {
  if (n == null || n === '') return '';
  const num = Number(n);
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('en-MY', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

/** Replaces children of `parent` with `newChildren`. */
export function render(parent, ...newChildren) {
  parent.replaceChildren(...newChildren.flat().filter(Boolean));
}

/** Escapes a string for safe insertion as text content. */
export function esc(s) {
  if (s == null) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
